const actions = {
    GET_BITACORAS_REQUEST: 'GET_BITACORAS_REQUEST',
    GET_BITACORA_BY_ID_REQUEST: 'GET_BITACORA_BY_ID_REQUEST',
    GET_REPARACIONES_REQUEST: 'GET_REPARACIONES_REQUEST',
    CREATE_BITACORA_REQUEST: 'CREATE_BITACORA_REQUEST',
    CREATE_REPARACION_REQUEST: 'CREATE_REPARACION_REQUEST',
    CREATE_REPARACION_SUCCESS: 'CREATE_REPARACION_SUCCESS',
    UPDATE_BITACORA_REQUEST: 'UPDATE_BITACORA_REQUEST',
    DELETE_BITACORA_REQUEST: 'DELETE_BITACORA_REQUEST',
    GET_ALERTAS_BITACORAS_REQUEST: 'GET_ALERTAS_BITACORAS_REQUEST',

    GET_BITACORAS_SUCCESS: 'GET_BITACORAS_SUCCESS',
    GET_BITACORA_BY_ID_SUCCESS: 'GET_BITACORA_BY_ID_SUCCESS',
    GET_REPARACIONES_SUCCESS: 'GET_REPARACIONES_SUCCESS',
    CREATE_BITACORA_SUCCESS: 'CREATE_BITACORA_SUCCESS',
    UPDATE_BITACORA_SUCCESS: 'UPDATE_BITACORA_SUCCESS',
    DELETE_BITACORA_SUCCESS: 'DELETE_BITACORA_SUCCESS',
    GET_ALERTAS_BITACORAS_SUCCESS: 'GET_ALERTAS_BITACORAS_SUCCESS',

    getBitacoras: (query) => ({ 
        type: actions.GET_BITACORAS_REQUEST, 
        payload: query 
    }),

    getBitacoraById: id => ({
        type: actions.GET_BITACORA_BY_ID_REQUEST,
        payload: id
    }),

    getReparacionesBitacora: id => ({
        type: actions.GET_REPARACIONES_REQUEST,
        payload: id
    }),

    createBitacora: (bitacora, history) => ({
        type: actions.CREATE_BITACORA_REQUEST,
        payload: bitacora,
        history
    }),

    createReparacionBitacora: (reparacion, bitacoraId) => ({
        type: actions.CREATE_REPARACION_REQUEST,
        payload: reparacion,
        bitacoraId
    }),

    updateBitacora: (id, bitacora) => ({
        type: actions.UPDATE_BITACORA_REQUEST,
        id: id,
        payload: bitacora
    }),
    deleteBitacora: id => ({
        type: actions.DELETE_BITACORA_REQUEST,
        payload: id
    }),

    getAlertas: () => ({ type: actions.GET_ALERTAS_BITACORAS_REQUEST}),
}

export default actions;